<template>
  <body class="p-3 absolute-bottom">
    <h2>{{ $t('src/pages/agreement.4316') }}</h2>

    <p>
      <strong>{{ $t('src/pages/agreement.531') }}</strong>
    </p>
    <p>{{ $t('src/pages/agreement.2023') }}</p>
    <ol>
      <li>{{ $t('src/pages/agreement.2688') }}</li>
      <li>{{ $t('src/pages/agreement.7319') }}</li>
      <li>{{ $t('src/pages/agreement.7393') }}</li>
      <li>{{ $t('src/pages/agreement.9125') }}</li>
    </ol>
    <p>{{ $t('src/pages/agreement.664') }}</p>

    <p>
      <strong>{{ $t('src/pages/agreement.9667') }}</strong>
    </p>
    <p>{{ $t('src/pages/agreement.9358') }}</p>
    <ol>
      <li>{{ $t('src/pages/agreement.3970') }}</li>
      <li>{{ $t('src/pages/agreement.4520') }}</li>
      <li>{{ $t('src/pages/agreement.9449') }}</li>
      <li>{{ $t('src/pages/agreement.571') }}</li>
      <li>{{ $t('src/pages/agreement.7994') }}</li>
      <li>{{ $t('src/pages/agreement.1674') }}</li>
    </ol>

    <p>
      <strong>{{ $t('src/pages/agreement.3974') }}</strong>
    </p>
    <ol>
      <li>{{ $t('src/pages/agreement.8643') }}</li>
      <li>{{ $t('src/pages/agreement.4836') }}</li>
      <li>{{ $t('src/pages/agreement.337') }}</li>
    </ol>
    <p>{{ $t('src/pages/agreement.2275') }}</p>
  </body>
</template>

<script>
export default {
  name: 'AgreementPage'
}
</script>
